import { createContext } from 'react';
import type { NavigationContextType } from '@/types/navigation';

export const KioskNavigationContext = createContext<NavigationContextType | null>(null);
